<template>
    <div class="content-part" v-if="content.type===1">
        <div :class="'big-title '+(content.open?'':'off')" @click="eventChangeOpen(content.open)">
            <h3>{{content.big_title}}</h3>
            <div class="i-circle">
                <i :class="'icon iconfont '+content.big_title_icon"></i>
            </div>
        </div>
        <div :class="'detail-part '+(content.open?'on':'off')" v-for="(detail_item, index) in content.detail_list"
             :key="index">
            <div class="detail-progress" v-if="!!detail_item.detail_progress">
                <div class="progress" v-for="(progress, i) in detail_item.detail_progress" :key="i">
                    <circle-progress :percent="progress.percent"/>
                    <div class="progress-text">{{progress.name}}</div>
                </div>
            </div>
            <div class="detail-tags" v-if="!!detail_item.detail_tags">
                <span class="tag" v-for="(tag, o) in detail_item.detail_tags" :key="o">{{tag}}</span>
            </div>
            <div class="detail-rows" v-if="!!detail_item.detail_rows">
                <ul>
                    <li v-for="(row, row_index) in detail_item.detail_rows" :key="row_index">{{row}}</li>
                </ul>
            </div>
            <div class="detail-desc" v-if="!!detail_item.detail_desc">{{detail_item.detail_desc}}</div>
            <div class="detail-urls" v-if="!!detail_item.detail_urls">
                <div class="url-part" v-for="(url_item, u) in detail_item.detail_urls" :key="u">
                    <span class="url-name">{{url_item.name}}：</span>
                    <a class="url-a" :href="url_item.url" target="_blank" title="点击跳转">{{url_item.url}}</a>
                    <span class="url-desc" v-if="!!url_item.desc">({{url_item.desc}})</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CircleProgress from './CircleProgress.vue'

    export default {
        props: {
            content: Object
        },
        components: {
            CircleProgress
        },
        methods: {
            eventChangeOpen(open) {
                this.content.open = !open;
            }
        }
    }
</script>

<style lang="scss" scoped>
@import "@/sass/mixin.scss";
@import "@/sass/reset.scss";
    .content-part {
        padding: 30px 30px 0 30px;
        border-left: 4px solid $color_a;
        color: $color_3;
        .big-title {
            cursor: pointer;
            position: relative;
            font-size: 26px;
            line-height: 50px;
            color: $color_a;
            font-weight: bold;
            &.off {
                color: $color_9;
                .i-circle {
                    background: $color_9;
                }
            }
            .i-circle {
                position: absolute;
                left: -31px;
                top: 50%;
                transform: translate(-50%, -50%);
                width: 46px;
                height: 46px;
                line-height: 46px;
                text-align: center;
                background: $color_a;
                border-radius: 100%;
                border: 4px solid $color_f;
                font-weight: bold;
                .icon {
                    color: $color_f;
                    font-size: 24px;
                }
            }
        }
        .detail-part {
            color: $color_3;
            margin-top: 6px;
            overflow: hidden;
            transition: max-height .4s;
            &.off {
                max-height: 0;
            }
            &.on {
                max-height: 1000px;
            }
            .detail-tags {
                font-size: 22px;
                padding-right: 100px;
                display: flex;
                justify-content: space-between;
                font-weight: bold;
                color: $color_4;
                .tag {
                    line-height: 40px;
                }
            }
            .detail-desc {
                line-height: 28px;
                font-size: 22px;
            }
            .detail-rows {
                padding: 6px 0;
                ul > li {
                    font-size: 22px;
                    line-height: 32px;
                }
            }
            .detail-progress {
                margin: 20px 0;
                display: flex;
                justify-content: space-between;
                .progress {
                    text-align: center;
                    font-size: 24px;
                    line-height: 30px;
                    .progress-text {
                        color: $color_4;
                        font-weight: bold;
                        margin-top: 8px;
                    }
                }
            }
            .detail-urls {
                .url-part {
                    line-height: 38px;
                    font-size: 22px;
                    .url-name {
                        display: inline-block;
                        min-width: 110px;
                    }
                    .url-a {
                        color: $color_3;
                        &:hover {
                            color: $color_a;
                        }
                    }
                    .url-desc {
                        font-size: 20px;
                        color: $color_3;
                        margin-left: 20px;
                    }
                }
            }
        }
    }
</style>
